import { createSlice } from "@reduxjs/toolkit";

export let uiSlice = createSlice({
  name: "ui",
  initialState: {
    modals: {},
    notifications: [],
  },
  reducers: {
    openModal: (state, { payload }) => {
      let { name, data } = payload;
      return { ...state, modals: { [name]: data } };
    },

    closeModal: (state, { payload }) => {
      return { ...state, modals: {} };
    },

    addNotification: (state, { payload }) => {
      let { message, type, id } = payload;
      return {
        ...state,
        notifications: [...state.notifications, { message, type, id }],
      };
    },

    removeNotification: (state, { payload }) => {
      let id = payload;
      return {
        ...state,
        notifications: state.notifications.filter((notif) => notif.id != id),
      };
    },
  },
});
